import * as globals from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

import {MAIN_CONTENT_WIDTH_CSS} from '../../../aria';

export const EmbeddedIframe = styled.iframe<{
  selected: boolean;
  // TODO: Refactor this to use flex or grid layout instead of calc.
  // See https://www.notion.so/wandbai/height-calc-100vh-60px-is-cursed-345e2f5c7ef3804795cfd6e62fb2f041
  // oxlint-disable-next-line wandb/no-calc-100vh-pixel-math
}>`
  display: block;
  margin: 0 auto;
  height: min(calc((${MAIN_CONTENT_WIDTH_CSS} - 128px) * 9 / 16), 603px);
  @media only screen and (max-width: 768px) {
    height: min(calc((100vw - 64px) * 9 / 16), 603px);
  }

  ${props =>
    props.selected &&
    css`
      box-shadow: 0 0 0 6px light-dark(rgb(208, 225, 252), var(--blue-700));
    `}
`;
